import React from "react";
import { useHistory } from "react-router-dom";
import { publicUrl } from "../../config/api";
import InactiveBook from "./InactiveBook";

function Book(props) {
  const history = useHistory();
  return (
    <div className="mt-12">
      <div
        className={`rounded-lg flex justify-center ${
          props.active === "false" ? " cursor-default " : "cursor-pointer "
        }`}
        onClick={() =>
          props.active === "false"
            ? ""
            : history.push(`/detail/${props.data.id}`)
        }
      >
        {props.active === "false" ? <InactiveBook /> : <></>}
        <div
          className={`${
            props.active === "false" ? "absolute inset-auto" : ""
          } flex-col py-2 pl-0 px-0 lg:px-1 px-auto justify-center items-center`}
        >
          <div className="rounded-md">
            <img
              className="mx-auto lg:mx-0 w-48 h-64 rounded-lg"
              src={`${publicUrl}/${props.data.thumbnailImg}`}
              alt=""
            />
          </div>
          <div className="text-center md:text-left">
            <h1 className="text-title text-2xl leading-7 font-bold mt-4 mb-2">
              {props.data.title}
            </h1>
            <p className="text-gray-500">{props.data.user.fullName}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Book;
